import { render, staticRenderFns } from "./FormPreview.vue?vue&type=template&id=351e80c2&"
import script from "./FormPreview.vue?vue&type=script&lang=js&"
export * from "./FormPreview.vue?vue&type=script&lang=js&"
import style0 from "./FormPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports